import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { TagField } from "../../components/app/TagField";
import RefreshIcon from '@mui/icons-material/Refresh';
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../App";
import isArray from "lodash/isArray";

export const RENDER_TAGS = (tags) => {
    if (tags) {
        if (!isArray(tags)) {
            tags = [tags];
        }
        const pronombre = tags.length > 1 ? 'los tags ' : 'el tag ';
        return (<>{pronombre} {
            tags.map((tag, index) => {
                return <span key={index} style={{ fontWeight: 450 }}>{`${index > 0 ? ', ' : ''}${tag.prefijo} ${tag.numero}`}</span>
            })
        }
        </>
        )
    }
}

export default function ConsultaTagPanel({ ...props }) {
    const navigate = useNavigate();
    let { state } = useLocation();
    const { notificar } = useContext(AppContext);

    const [data, setData] = useState({ prefijo: 'IMDM', numero: '' });
    const [resetTag, setResetTag] = useState(0);

    return (
        <>
            <Typography variant="body1" color="secondary" sx={{ fontWeight: 450 }}>Búsqueda de tag</Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'baseline' }}>
                <TagField
                    div
                    value={{ prefijo: data.prefijo, numero: data.numero, div: data.div }}
                    reset={resetTag}
                    onChange={(value, valid) => {
                        if (valid) {
                            setData({ ...data, ...value });
                            navigate(`registros/tags/${value.prefijo}/${value.numero}`, { state: { ...state } });
                        } else {
                            setData({ ...data, prefijo: 'IMDM', numero: '' });
                        }
                    }}
                />
                <Tooltip title="Reset tag">
                    <IconButton onClick={() => setResetTag(resetTag + 1)}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
        </>
    )
}